function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { j as l } from "./index.es33.js";
import { clsx as m } from "./index.es105.js";
import { Typography as p } from "./index.es35.js";
import "./index.es36.js";
import { calculatePlaceholder as c } from "./index.es686.js";
import e from "./index.es659.js";

var n = function n(_ref) {
  var o = _ref.isFocused,
      r = _ref.isOpen,
      a = _ref.placeholder,
      t = _ref.isDisabled;
  return l.jsx("div", {
    className: e.placeholder,
    style: {
      left: "12px"
    },
    children: l.jsx(p.Body2, {
      className: m(e.placeholderItem, _defineProperty({}, e.placeholderDisabled, t)),
      children: c({
        isFocused: o,
        isOpen: r,
        placeholder: a
      })
    })
  });
};

export { n as InitialPlaceholder };